export { default } from "./LeadForm.component";
